/* eslint-disable @direct-frontend/modules/slice-boundaries -- характеристики нужны для списка параметров сопоставления */
import { useMemo } from 'react';
import { useCharacteristicsGetAll } from '#entities/characteristic';
import { type TagWithScope } from '#shared/lib/integrations';
import { buildIntegrationMappingAvailableItems } from '../lib/buildIntegrationMappingAvailableItems';

type UseIntegrationMappingAvailableItemsParams = {
    selectedTags: TagWithScope[];
};

export const useIntegrationMappingAvailableItems = ({ selectedTags }: UseIntegrationMappingAvailableItemsParams) => {
    const { data: characteristics, isError, isFetching, refetch } = useCharacteristicsGetAll({});

    const availableItems = useMemo(
        () => buildIntegrationMappingAvailableItems(characteristics ?? [], selectedTags),
        [characteristics, selectedTags]
    );

    return {
        availableItems,
        isFetching,
        isError,
        onRetry: refetch,
    };
};
